// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".removal[data-v-728eb8b2]{display:flex;align-items:center;background-color:transparent;border:none;cursor:pointer;font-size:14px;line-height:20px;color:#4c5a67;padding:0}.removal svg[data-v-728eb8b2]{margin-right:8px;font-size:16px;color:#4c5a67}", ""]);
// Exports
module.exports = exports;
